import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateIntegration($companyId: ID!, $attributes: IntegrationAttributes!) {
    createIntegration(companyId: $companyId, attributes: $attributes) {
      integration {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
